module.exports = __webpack_public_path__ + "media/חלום.71d221ca.mp3";